import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

const initialState: { data: number[] } = {
  data: [],
};

export const multiSelect = createSlice({
  name: 'multiSelect',
  initialState,
  reducers: {
    addVacation: (state, { payload }: PayloadAction<number>) => {
      state.data.push(payload);
    },
    deleteVacation: (state, { payload }: PayloadAction<number>) => {
      state.data = state.data.filter(elem => elem !== payload);
    },
    resetVacations: (state, { payload }: PayloadAction<void>) => {
      state.data = [];
    },
    setVacations: (state, { payload }: PayloadAction<number[]>) => {
      state.data = payload;
    },
  },
});

const multiSelectedVacations = (state: RootState) => state.entities.vacations.multiSelect;
export const getMultiSelectedVacations = createSelector(multiSelectedVacations, state => state);

export const { addVacation, deleteVacation, resetVacations, setVacations } = multiSelect.actions;
export const reducer = multiSelect.reducer;
